import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { SignalRConfiguration, SignalRModule } from 'ng2-signalr';
import { AnnotazioniDelSistemaComponent } from './annotazioni-del-sistema/annotazioni-del-sistema.component';
import { AnnotazioniComponent } from './annotazioni/annotazioni.component';
import { AtecoEditFormComponent } from './ateco-edit-form/ateco-edit-form.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { DialogRicalcolaConTicketComponent } from './dialog-ricalcola-con-ticket/dialog-ricalcola-con-ticket.component';
import { EditNotaModalComponent } from './edit-nota-modal/edit-nota-modal.component';
import { ErrorAlertComponent } from './error-alert/error-alert.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FilesUploadComponent } from './files-upload/files-upload.component';
import { InpsCapthcaModalComponent } from './inps/inps-capthca-modal/inps-capthca-modal.component';
import { JsonModalComponent } from './json-modal/json-modal.component';
import { PipesModule } from './pipes/pipes.module';
import { RapportoElaborazioneModalComponent } from './rapporto-elaborazione-modal/rapporto-elaborazione-modal.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { TableComponent } from './table/table.component';
import { BasicModalComponent } from './basic-modal/basic-modal.component';

export function createConfig(): SignalRConfiguration {
    const c = new SignalRConfiguration();
    // c.hubName = 'notificheStudioHub';
    // c.url = environment.apiUrl;
    c.logging = true;
    c.withCredentials = true;
    return c;
}

const MaterialModules = [
    MatSnackBarModule,
    MatIconModule,
    MatTableModule,
    MatToolbarModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatInputModule,
    MatCardModule,
    MatDividerModule,
];

@NgModule({
    declarations: [
        ErrorModalComponent,
        JsonModalComponent,
        InpsCapthcaModalComponent,
        RapportoElaborazioneModalComponent,
        EditNotaModalComponent,
        SuccessModalComponent,
        ConfirmModalComponent,
        TableComponent,
        AtecoEditFormComponent,
        ErrorAlertComponent,
        AnnotazioniComponent,
        AnnotazioniDelSistemaComponent,
        FilesUploadComponent,
        BasicModalComponent,
        DialogRicalcolaConTicketComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ...MaterialModules,
        FlexLayoutModule,
        ReactiveFormsModule,
        PipesModule,
        DirectivesModule,
        SignalRModule.forRoot(createConfig),
    ],
    exports: [TableComponent, AtecoEditFormComponent, ErrorAlertComponent, AnnotazioniComponent, AnnotazioniDelSistemaComponent, FilesUploadComponent],

    entryComponents: [ErrorModalComponent, JsonModalComponent, InpsCapthcaModalComponent, RapportoElaborazioneModalComponent, EditNotaModalComponent, DialogRicalcolaConTicketComponent],
})
export class SharedModule {}
